import React from 'react';
import {formatNumber} from '../../../assets/utils/utils';
import {useTranslation} from 'react-i18next';
import PanelButton from '../../../Components/Buttons/PanelButton';
import {useGetProfitMonthQuery} from '../../../redux/userClientsApi';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import s from './MonthProfit.module.css';

const MonthProfit = ({
	month,
	handleCalendar,
}: {
	month: string;
	handleCalendar: () => void;
}) => {
	const {t} = useTranslation();
	const {data, isLoading} = useGetProfitMonthQuery(month);
	if (isLoading)
		return <PreLoaderComponent type={'gallery'} size={'compact'} />;
	if (!isLoading && data)
		return (
			<div className={s.monthProfit}>
				<div className={s.profitTop}>
					<div className={s.profitIcon} />
					<div className={s.profitLabel}>{data.month}</div>
					<div className={s.profitLabel}>
						<PanelButton
							color={'brownButton'}
							onClickButton={handleCalendar}
							name={'Оберіть місяць '}
							type={'button'}
						/>{' '}
					</div>
				</div>
				<div className={s.profitSum}>
					{data.bonus_points && formatNumber(data.bonus_points)}
					<span>{t('Бонусів')}</span>
				</div>
			</div>
		);
	else return null;
};

export default MonthProfit;
